import { Component, OnInit, Input } from '@angular/core';
import { Kursteilnehmer } from '../_models/teilnehmer';
import { AnwesenheitService } from '../_services/anwesenheit.service';
import { Fehlzeiten } from '../_models/fehlzeiten';
//import { KursFehlzeit } from './kursfehlzeit.component';
import { Kurs } from '../_models/kurs';

@Component({
  selector: 'app-student-details',
  templateUrl: './student-details.component.html',
  styles: []
})
export class StudentDetailsComponent implements OnInit {

  @Input() student: Kursteilnehmer;
  @Input() course: Kurs;
  //absencesToday: Fehlzeiten[];

  constructor(private absencesService: AnwesenheitService) { }

  ngOnInit() {
    //console.log(this.student.Fehlstunden);
  }


}



// WEBPACK FOOTER //
// ./src/app/_components/student-details.component.ts